/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/rules-of-hooks */
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { useState, useEffect, SetStateAction } from "react";
import ThemeMaker from "../../components/thememaker";
import { config } from "../../utils/config";
import axios from "axios";
import { Paginated } from "../../components/Paginated";
import "../../index.css";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import SearchIcon from '@mui/icons-material/Search';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import CloseIcon from '@mui/icons-material/Close';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import brandStyles from "../Brand/Brand.module.css";
import Styles from "./LogRejection.module.css";
import "../../components/mcrbTableTheme.css";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';


const logRejection = () => {

    const { apiEndpoint, baseNodeapiUrl } = config;
    const [toggleState, setToggleState] = useState(1);
    const [details, setDetails]: any = useState('');
    const [isDetailsLoading, setIsDetailsLoading] = useState(false);
const getDateString = (date: Date) => {
    return date.toISOString().split("T")[0];
};

const today = new Date();

const oneMonthAgo = new Date(today);
oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

const [startDate, setStartDate] = useState(getDateString(oneMonthAgo));
const [endDate, setEndDate] = useState(getDateString(today));
    const [errorList, setErrorList]: any = useState([]);
    const [manageFilter, setManageFilter]: any = useState([]);
    const [open, setOpen] = useState(false);
    const modelOpen = () => setOpen(true);
    const [searchQuery, setSearchQuery] = useState('');

    const handleClose = () => {
        setOpen(false);
    };
    const toggleTab = (e: any) => {
        setToggleState(e);
    };





    const Mstyle = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "50%",
        maxWidth: "600px",
        borderRadius: "16px",
        bgcolor: 'background.paper',
        border: 'none',
        outline: 'none',
        boxShadow: '0 20px 50px rgba(43, 22, 87, 0.24)',
        p: 0,
        overflow: 'hidden',
    };
    // 
    const handleStartDateChange = (event: any) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event: any) => {
        setEndDate(event.target.value);
    };

    const getErrorData = async (data: any) => {
        try {
            const result = await data ? data : "";
            setDetails(result)
        } catch (error) {
            console.error("Error occurred:", error);
        }
    }

    const totalSettlementAmount = async () => {
        try {
            const date = {
                // start_date: "2024-06-01 00:00:00.4+00",
                end_date: new Date()
            }
            setIsDetailsLoading(true)
            const { data } = await axios({
                url: `${baseNodeapiUrl}/get_catalog_rejection`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
                },
                data: {
                    startDate: startDate,
                    endDate: endDate
                }
            });
            const hasData = data?.data && data?.data?.length > 0;
            setErrorList(hasData ? [...(data?.data || [])] : []);
            setManageFilter(hasData ? [...(data?.data || [])] : []);
            setIsDetailsLoading(false)
        } catch (error) {
            console.log("Something Went Wrong!", error)
            setIsDetailsLoading(false)
        }
    };

    // FILTER
    const filterBySearch = (event: any) => {
        setSearchQuery(event.target.value)
        const querySearch = event.target.value.toLowerCase();
        const filteredResults = errorList.filter((item: any) => {
            return (
                item?.body?.context?.transaction_id?.toString()?.includes(querySearch) ||
                item?.body?.context?.bap_id?.toString()?.includes(querySearch)
            );
        });
        setManageFilter(filteredResults);
        console.log("filteredResults", filteredResults)
    };

    const exportToCSV = (orderList: any) => {
        const headers = [
            'S.No',
            'Buyer Id',
            'City Code',
            'Transaction Id',
            'Error Massage',
            'Path'
        ];
        const data = manageFilter.map((item: any, i: any) => {
            const errors = item?.body?.errors || [];
            const massages = errors.map((error: any) => error?.message).join(' | ');
            const paths = errors.map((error: any) => error?.path).join(' | ');

            return [
                i + 1,
                item?.body?.context?.bap_id || '',
                item?.body?.context?.city || '',
                item?.body?.context?.transaction_id || '',
                massages,
                paths,
            ].join(',');
        });
        const csvContent = [headers.join(','), ...data].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `orders_${new Date().getTime()}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    const COLUMNS = [
        {
            Header: "Sn.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Buyer Id",
            accessor: (item: any) => <span style={{ color: "#1F2430", fontWeight: 700, fontFamily: "'Sora', 'Inter', sans-serif" }}>{item?.body?.context?.bap_id ? item?.body?.context?.bap_id : ""}</span>,
            sticky: "left"
        },
        {
            Header: "City Code",
            accessor: (item: any) => (item?.body?.context?.city ? item?.body?.context?.city : ""),
            sticky: "left"
        },
        {
            Header: "Transaction Id",
            accessor: (item: any) => (item?.body?.context?.transaction_id ? item?.body?.context?.transaction_id : ""),
            sticky: "left"
        },
         {
            Header: "Date",
            accessor: (item: any) => (item?.body?.context?.timestamp ? item?.body?.context?.timestamp : ""),
            sticky: "left"
        },
        {
            Header: "Error Description",
            accessor: (a: any) => {
                return (
                    <span className={brandStyles.iconBtn} onClick={() => { getErrorData(a?.body ? a?.body : ""); modelOpen() }}>
                        <VisibilityOutlinedIcon style={{ color: "#4c2fb3" }} titleAccess="View Error" />
                        
                    </span>
                )
            },
            sticky: "left"
        },
    ];

    useEffect(() => {
        totalSettlementAmount();
    }, [startDate, endDate]);
    // console.log("manageFilter", manageFilter);
    return (
        <>
            <ThemeMaker>
                <div className={`${Styles.pageWrap} mcrb-page`}>
                    <div className={`${brandStyles.cardOuter} mcrb-card`}>
                        <div className={brandStyles.headerBar}>
                            <span className={brandStyles.title}>Catalog Rejection</span>
                            {toggleState === 1 ? (
                                <button type="button" className={Styles.downloadBtn} onClick={() => exportToCSV(manageFilter)}>
                                    <DownloadRoundedIcon style={{ fontSize: 18 }} />
                                    Download Details
                                </button>
                            ) : null}
                        </div>

                        <div className={Styles.toolbarRow}>
                            <div className={Styles.field}>
                                <label htmlFor="searchInput" className={Styles.label}>Search by</label>
                                <div className={Styles.searchBox} style={{width:"400px"}}>
                                    <SearchIcon style={{ fontSize: 18, color: "#9CA3AF" }} />
                                    <input type="search" name="search" value={searchQuery} placeholder="Buyer ID or Transaction ID.." onChange={(event) => filterBySearch(event)} />
                                </div>
                            </div>
                            <div className={Styles.field}>
                                <label htmlFor="start-date" className={Styles.label}>Start Date</label>
                                <input type="date" className={Styles.dateInput} placeholder="Select a date" id="start-date"
                                    value={startDate} onChange={(e: any) => handleStartDateChange(e)} />
                            </div>
                            <div className={Styles.field}>
                                <label htmlFor="end-date" className={Styles.label}>End Date</label>
                                <input type="date" className={Styles.dateInput} value={endDate} id="end-date" onChange={(e: any) => handleEndDateChange(e)} />
                            </div>
                        </div>

                       <div className={`${brandStyles.bodyArea} ${brandStyles.tableWrap}`}>
                            {isDetailsLoading ? (
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{ minHeight: "60vh" }}
                                >
                                    <CircularProgress />
                                </div>
                            ) : manageFilter?.length > 0 ? (
                                <Paginated data={manageFilter} columns={COLUMNS} />
                            ) : (
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{
                                        minHeight: "300px",
                                        fontSize: "16px",
                                        fontWeight: 600,
                                        color: "#6B7280",
                                    }}
                                >
                                    No Data Found
                                </div>
                            )}
                        </div>
                    </div>

                    <Modal open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description">
                        <Box sx={Mstyle}>
                            <div className={Styles.modalHeader}>
                                <div className={Styles.modalHeaderText}>
                                    <p className={Styles.modalTitle}>Transaction ID: {details?.context?.transaction_id}</p>
                                    {details?.context?.city ? <span className={Styles.modalCityChip}>{details?.context?.city}</span> : null}
                                </div>
                                <span className={Styles.modalClose}><CloseIcon onClick={() => handleClose()} /></span>
                            </div>
                            <div className={Styles.modalBody}>
                                {!isDetailsLoading ? (
                                    details?.errors?.length > 0 ? details.errors.map((item: any, idx: number) => (
                                        <div className={Styles.errorBlock} key={idx}>
                                            <div className={Styles.errorRow}>
                                                <div className={Styles.errorLabel}>Message</div>
                                                <div className={Styles.errorValue}>{item?.message || "-"}</div>
                                            </div>
                                            <div className={Styles.errorRow}>
                                                <div className={Styles.errorLabel}>Path</div>
                                                <div className={Styles.errorValue}>{item?.path || "-"}</div>
                                            </div>
                                        </div>
                                    )) : (
                                        <div className={Styles.errorBlock}>
                                            <p className="text-center mb-0">No errors found.</p>
                                        </div>
                                    )
                                ) : (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "160px" }}>
                                        <CircularProgress size={28} />
                                    </div>
                                )}
                            </div>
                        </Box>
                    </Modal>
                </div>
            </ThemeMaker >
        </>
    )
}

export default logRejection;